// extracted by mini-css-extract-plugin
module.exports = {"tab":"index-module__tab___0uE3+"};